<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="this.lang.polaris.account.accounts_management" :actions="card_actions" :bus="bus">
            <trax-account-user-crud-table :bus="bus" :with-username="withUsername"></trax-account-user-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default id="trax-account-user-edit" :bus="bus">
            <trax-account-user-crud-form :bus="bus" :with-username="withUsername"></trax-account-user-crud-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm id="trax-account-user-delete" :title="this.lang.polaris.account.user_deletion" :bus="bus">
            {{ lang.polaris.account.confirm_delete_account_q }}
        </trax-ui-modal-confirm>
    
        <!-- Search modal -->

        <trax-ui-modal-default id="trax-account-user-search" :bus="bus" :title="lang.polaris.form.advanced_search">
            <trax-account-user-crud-search id="trax-account-user" :bus="bus"></trax-account-user-crud-search>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr id="trax-account-user-toastr" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: ['withUsername'],

        data: function() {
            return {
                lang: lang,
                user: user,
                id: 'trax-account-user',
                endpoint: app_url+"polaris/api/front/users",
                bus: new Vue()
            }
        },

        created: function() {
            this.bus.$on(this.id+'-login-as', this.loginAs);
        },

        computed: {

            canManage() {
                return this.user.admin || this.user.permissions['user.manage'] ? true : false;
            },

            // The supervisors don't create accounts.
            card_actions() {
                var actions = [
                    { icon: 'search', event: 'trax-account-user-search-open' }
                ];
                if (this.canManage) {
                    actions.push({ icon: 'add_box', event: 'trax-account-user-edit-create' });
                }
                return actions;
            }
        },

        methods: {

            // Use the account of the row: the back-end swaps the session and returns the
            // landing URL. Reserved to super-admins, and refused on some accounts.
            loginAs: function(row) {
                var that = this;
                axios.post(this.endpoint+'/'+row.id+'/login-as')
                    .then(function (response) {
                        window.location = response.data.redirect;
                    })
                    .catch(function (error) {
                        that.bus.$emit(
                            that.id+'-toastr-error',
                            that.lang.polaris.account.login_as_failed
                        );
                    });
            }
        }
    }
</script>
